import { LinesState, LinesTypes } from './types';

export const INITIAL_STATE: LinesState = {
  lineData: {
    id: '',
    name: '',
    prefix: '',
    status: 0,
    visible: true,
    type: 0,
    distributionType: 0,
    lineType: 0,
    lineFunction: 0,
    model: 0,
    sector: '',
    system: '',
    operation: 0,
    color: '',
    minVelocity: 0,
    maxVelocity: 0,
    updatedAt: '',
    createdAt: '',
    lineLotId: '',
    transportOperatorId: '',
  },
  linesList: [],
  conectivityData: {
    purchases: [],
    usages: [],
    offlines: [],
    onlines: [],
    exits: [],
  },
  conectivityDataPlanList: [],
  totalCount: 0,
  error: false,
  loading: false,
  conectivityError: '',
  internalCode: '',
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

const listLinesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  linesList: INITIAL_STATE.linesList,
});

const listLinesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  linesList: action.payload.linesList,
  totalCount: action.payload.totalCount,
});

const listLinesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  linesList: INITIAL_STATE.linesList,
});

// Filter Stops
const filterLinesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  linesList: INITIAL_STATE.linesList,
});

const filterLinesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  totalCount: action.payload.totalCount,
  linesList: action.payload.linesList,
});

const filterLinesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  linesList: INITIAL_STATE.linesList,
});

// Get Line
const getLineRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineData: INITIAL_STATE.lineData,
});

const getLineSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineData: action.payload.lineData,
});

const getLineFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineData: INITIAL_STATE.lineData,
});

// Create Line
const createLineRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  lineData: INITIAL_STATE.lineData,
});

const createLineSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  lineData: action.payload.lineData,
});

const createLineFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  lineData: INITIAL_STATE.lineData,
});

// Update Line
const updateLineRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateLineSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateLineFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Line
const deleteLineRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteLineSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteLineFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Line Benefits
const updateLineBenefitsRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateLineBenefitsSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateLineBenefitsFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Get Conectivity
const conectivityRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  conectivityData: INITIAL_STATE.conectivityData,
});

const conectivitySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  conectivityData: action.payload.conectivityData,
});

const conectivityDataPlanSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  conectivityDataPlanList: action.payload.conectivityDataPlanList,
});

const conectivityFailure = (state: any, action: any) => ({
  ...state,
  loading: false,
  conectivityError: action.payload.conectivityError,
  internalCode: action.payload.internalCode,
  conectivityData: INITIAL_STATE.conectivityData,
});

const reducer = createReducer(INITIAL_STATE, {
  [LinesTypes.LIST_LINES_REQUEST]: listLinesRequest,
  [LinesTypes.LIST_LINES_SUCCESS]: listLinesSuccess,
  [LinesTypes.LIST_LINES_FAILURE]: listLinesFailure,

  [LinesTypes.FILTER_LINES_REQUEST]: filterLinesRequest,
  [LinesTypes.FILTER_LINES_SUCCESS]: filterLinesSuccess,
  [LinesTypes.FILTER_LINES_FAILURE]: filterLinesFailure,

  [LinesTypes.GET_LINE_REQUEST]: getLineRequest,
  [LinesTypes.GET_LINE_SUCCESS]: getLineSuccess,
  [LinesTypes.GET_LINE_FAILURE]: getLineFailure,

  [LinesTypes.CREATE_LINE_REQUEST]: createLineRequest,
  [LinesTypes.CREATE_LINE_SUCCESS]: createLineSuccess,
  [LinesTypes.CREATE_LINE_FAILURE]: createLineFailure,

  [LinesTypes.UPDATE_LINE_REQUEST]: updateLineRequest,
  [LinesTypes.UPDATE_LINE_SUCCESS]: updateLineSuccess,
  [LinesTypes.UPDATE_LINE_FAILURE]: updateLineFailure,

  [LinesTypes.DELETE_LINE_REQUEST]: deleteLineRequest,
  [LinesTypes.DELETE_LINE_SUCCESS]: deleteLineSuccess,
  [LinesTypes.DELETE_LINE_FAILURE]: deleteLineFailure,

  [LinesTypes.UPDATE_LINE_BENEFITS_REQUEST]: updateLineBenefitsRequest,
  [LinesTypes.UPDATE_LINE_BENEFITS_SUCCESS]: updateLineBenefitsSuccess,
  [LinesTypes.UPDATE_LINE_BENEFITS_FAILURE]: updateLineBenefitsFailure,

  [LinesTypes.CONECTIVITY_REQUEST]: conectivityRequest,
  [LinesTypes.CONECTIVITY_SUCCESS]: conectivitySuccess,
  [LinesTypes.CONECTIVITY_FAILURE]: conectivityFailure,
  [LinesTypes.CONECTIVITY_DATA_PLAN_SUCCESS]: conectivityDataPlanSuccess,
});

export default reducer;
